import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export default function SidebarItem({ label, goToPath, icon, clearFilters, isChild }) {
  const location = useLocation();
  const isCurrentLocation = goToPath === location.pathname;

  return (
    <li title={label} onClick={clearFilters} className={isCurrentLocation ? "active" : ""}>
      <NavLink to={goToPath}>
        <i className={`color-blanco-megatone me-1 ${icon}`}/>
        <span className={`color-blanco-megatone ${isChild ? "" : "hide-menu"}`}>{label}</span>
      </NavLink>
    </li>
  )
}